import React from 'react';

const AgedCareWiseLogo = ({ className = 'h-20 w-auto', showText = true, variant = 'full' }) => {
    const suffix = variant === 'symbol' ? '-symbol' : '-full';
    const navyId = 'agedCareGradient' + suffix;
    const tealId = 'wiseGradient' + suffix;

    const gradients = (
        <defs>
            <linearGradient id={navyId} x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#001E7A" />
                <stop offset="100%" stopColor="#0F52E0" />
            </linearGradient>
            <linearGradient id={tealId} x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#0290F5" />
                <stop offset="100%" stopColor="#1EC8FF" />
            </linearGradient>
        </defs>
    );

    if (variant === 'symbol') {
        return (
            <div className={className}>
                <svg viewBox="0 0 380 36" className="h-full w-auto" aria-hidden="true">
                    {gradients}
                    <text x="0" y="28" fontSize="24" fontWeight="800" fontFamily="'Inter', 'Segoe UI', sans-serif" letterSpacing="-0.8">
                        <tspan fill={'url(#' + navyId + ')'}>AgedCare</tspan>
                        <tspan fill={'url(#' + tealId + ')'}>Wise</tspan>
                    </text>
                </svg>
            </div>
        );
    }

    return (
        // min-w-0 + max-w-full: on a phone the wordmark shrinks to the room it has (left-aligned)
        // instead of forcing the whole page to scroll sideways.
        <div className={'flex items-center min-w-0 max-w-full ' + className}>
            <svg viewBox="0 0 400 48" preserveAspectRatio="xMinYMid meet" className="h-full w-auto max-w-full" role="img" aria-label="AgedCareWise">
                {gradients}
                {showText && (
                    <text x="0" y="38" fontSize="32" fontWeight="800" fontFamily="'Inter', 'Segoe UI', sans-serif" letterSpacing="-1.0">
                        <tspan fill={'url(#' + navyId + ')'}>AgedCare</tspan>
                        <tspan fill={'url(#' + tealId + ')'}>Wise</tspan>
                    </text>
                )}
            </svg>
        </div>
    );
};

export default AgedCareWiseLogo;
